import React, { useEffect, useRef, useState } from "react";
import { EmtMarketRateConfig } from "./AddEmtMArketRate.config";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import { Confirm } from "../../Confirmation/Confirm";
import PortalFooter from "../../Reactportal/PortalFooter";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import Reactportal from "../../Reactportal/Reactportal";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import Button from "../../Button/Button";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  CreateMarketRate,
  delete_Market_Rate,
  EDIT_MARKET_RATE,
  getMarket_RateByID,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import {
  GET_VEHICLE_CATEGORY,
  GET_VEHICLE_TYPE,
} from "../AddVendorAccount/UserPreferenceAndVehicleCategory/SelectedLanes";
import { MultiSelectionComponent } from "../../MultiSelectionComponent/MultiSelectionComponent";
import { RiErrorWarningFill } from "react-icons/ri";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import { useGetPageData } from "../../../custom_hooks/useGetPageData";
import "./AddEmtMarketRates.scss";
import { convertToISO, IsoToDateWithoutTime } from "../../../../CommonFunction/IsoDateTime";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import { useModalContext } from "../../Reactportal/ModalContext";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";


const AddEmtMarketRate = ({ show, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const Form_Key = "Emt_Market_Rates";
  const [isFirstLoad, setFirstLoad] = useState(false);
  const { pushModal, popModal } = useModalContext();
  const [field, setFields] = useState(TypeOfPortal === "Merge" ? "" : EmtMarketRateConfig);
  const [ConfirmMerge, SetConfirmMerge] = useState(false);
  const [toggle, settoggle] = useState(show ? show : false);
  // const [alldata, setalldata] = useState({});
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.[Form_Key]?.Selected_Row;
  const [allFieldsData, setAllFieldsData] = useState();
  const { fields } = useGetPageData();
  const [FormData, setFormdata] = useState({});
  const formRef = useRef({});
  const [initialData,setInitialData]=useState({})
  const {isDisabled}=useIsDisabled({TypeOfPortal,initial:initialData, current:FormData});


  //CRUD operations
  const [CreatingData, { loading: createEmtMarketRateLoading }] = useMutation(CreateMarketRate, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });
  const [GetDataByID, { loading: GetDataByIDLoader }] = useLazyQuery(getMarket_RateByID, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [EditingData, { loading: editEmtMarketRateLoading }] = useMutation(EDIT_MARKET_RATE(fields), {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [DeletingData, { loading: deleteEmtMarketRateLoading }] = useMutation(delete_Market_Rate, {
    fetchPolicy: "network-only",
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [selectedRows, setSelectedRows] = useState([]);
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [vehicleCategory, setCategory] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [searchValues, setSearchValues] = useState({ category_Value: "", type_Value: "" });

  const EmtMarketRateLoadingState =
    createEmtMarketRateLoading || editEmtMarketRateLoading || deleteEmtMarketRateLoading || GetDataByIDLoader;
  // || editAccountingGroupLoading || MergeAccountGroupLoading ? true : false;

  const HanldeChangeonForm = (values) => {
    setFormdata(prev=>{
      const next = {...prev,...values};
      if(!isFirstLoad){
        setInitialData(next)
      }
      return next
    })
  };


  useEffect(() => {
    setSelectedRows(fielddataRedux?.[Form_Key]?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key)
    }
  }, []);


  useEffect(() => {
    const input = document.getElementsByName("Date");
    if (input.length > 0 && !TypeOfPortal?.includes("View")) {
      input[input.length - 1].focus();
    }
  }, []);

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    if (TypeOfPortal !== "Add"&& TypeOfPortal !== "Delete") {
      GetDataByID({
        variables: {
          id: fielddata?._id,
        },
      }).then(({ data }) => {
        let MarketRateData = { ...data?.Market_RateByID };
        console.log(MarketRateData, "MArketDAta");
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: MarketRateData,
          },
        });
        setSearchValues({
          category_Value: MarketRateData?.Vehicle_Category?.Search_Value,
          type_Value: MarketRateData?.Vehicle_Type?.Search_Value,
        });
        const updatedMarketRateData = { ...MarketRateData };
        updatedMarketRateData.Date = IsoToDateWithoutTime(MarketRateData.Date);
        setAllFieldsData(updatedMarketRateData);
        updateValueForm(formRef, updatedMarketRateData);
      });
    } else {
      setAllFieldsData(TypeOfPortal === "Add" ? { Date: GetTodaysDateINdmy() } : fielddata);
      const currentDateInDMY = GetTodaysDateINdmy();
      updateValueForm(formRef, {
        Date: currentDateInDMY,
      });
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: {
            Date: currentDateInDMY,
          },
        },
      });
    }
  }, [fielddata]);

  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData = FormData;
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);
  console.log(variables, "variablesObj");
  const MutationFunctions = {
    CreatingData,
    EditingData,
    DeletingData,
  };

  const submit = async (closeAction) => {
    if (vehicleCategory) {
      formData.Vehicle_Category = vehicleCategory;
    }
    if (vehicleType) {
      formData.Vehicle_Type = vehicleType;
    }
    formData.Date = convertToISO(formData.Date);

    const mutationFunction = getMutationFunction(operationType, MutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: (obj) => {
        setAllFieldsData({});
        setCategory("");
        setVehicleType("");
        setSearchValues({ type_Value: "", category_Value: "" });
      },
      onSuccess: () => {
        setSearchValues({ type_Value: "", category_Value: "" });
        handleFormReset(formRef);
      },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = () => {

    ParentPortalCloseFunction();
    settoggle(false);
    setCategory("");
    setVehicleType("");
    setAllFieldsData({});
    setSearchValues({ type_Value: "", category_Value: "" });
    ClearSpecificForm(dispatch, Form_Key);
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };


  const storeSelectedData = (selectedCat, type, ckeck) => {
    if (ckeck) {
      setSearchValues({ type_Value: selectedCat?.Search_Value, category_Value: type?.Search_Value });
      setCategory(type?._id);
      setVehicleType(selectedCat?._id);
    } else {
      setSearchValues({ type_Value: "", category_Value: "" });
      setCategory("");
      setVehicleType("");
    }
  };

  const handleAdd_vehicle_number = () => {
    setShowModal(true);
  };
  console.log(searchValues);
  if (TypeOfPortal === "Delete") {
    return (
      <Reactportal open={toggle} onClose={() => settoggle(false)} TypeOfPortal={"Confirm"}>
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={EmtMarketRateLoadingState}
        />
      </Reactportal>
    );
  }
  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={isDisabled}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      SaveAndClose={
        TypeOfPortal === "Add" ? () => Validate_handleSubmit(SaveAndCloseForAdd) : () => Validate_handleSubmit(submit)
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={EmtMarketRateLoadingState}
    />
  );
  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={TypeOfPortal + " Emt Market Rate"}
        >
          <>
            {showModal && (
              <MultiSelectionComponent
                firstLevelQuery={GET_VEHICLE_TYPE}
                secondLevelQuery={GET_VEHICLE_CATEGORY}
                storeSelectedData={storeSelectedData}
                show={showModal}
                Closeformfunction={() => {
                  setShowModal(false);
                }}
                submit={() => {
                  setShowModal(false);
                }}
                selectedData={vehicleCategory}
                handleCancle={() => setShowModal(false)}
              />
            )}
            {EmtMarketRateLoadingState && <div className="loader-line-div" />}
            <div className="formContainer">
              {field &&
                field.map((e) => {
                  return (
                    <div key={e.id} className="FormSectionParent">
                      <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                      <div className="FormSection insidecontainer">
                        <FormInputSectionComponent
                          handelformikdata=""
                          inputfields={e.fields}
                          Type={e.name}
                          onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                          onhandleFormikChange={HanldeChangeonForm}
                          formkey={Form_Key}
                          formRef={formRef}
                          setFirstLoad={setFirstLoad}
                        />
                        <div className="vehicle_category">
                          <p className="Vehicle_Category">Vehicle Category</p>
                          <Button
                            children=""
                            disabled=""
                            action={handleAdd_vehicle_number}
                            text={vehicleCategory ? "Selected" : "Select"}
                            name={"modalbutton"}
                            type={""}
                          />
                        </div>

                        <div className="SearchValuesOfCatAndType">
                          {searchValues?.type_Value || ""}
                          {(searchValues?.category_Value && ", ") || ""}
                          {searchValues?.category_Value || ""}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </>
        </Reactportal>
      </div>
      {ConfirmMerge && (
        <Confirm
          submit={submit}
          settoggle={SetConfirmMerge}
          toggle={ConfirmMerge}
          loadingState={EmtMarketRateLoadingState}
          submitType={"Confirm Merge"}
          TypeOfPortal={"Confirm"}
        />
      )}
    </>
  );
};

export default AddEmtMarketRate;
